export const RETURN_TO_APPLICATION_AUTO = 'return_to_application_auto'
export const INSTANT_DASHING_V2 = 'instant_dashing_v2'
export const IS_AT_CAPACITY_V2 = 'is_at_capacity_v2'
export const DX_CRO_LP_GRADUATION_Q1_2020 = 'dx_cro_lp_graduation_q1_2020'
export const DX_CRO_LP_GRADUATION_Q3_2020 = 'dx_cro_lp_graduation_q3_2020'
export const DX_ID_FAST_PAY_Q1_2020 = 'dx_id_fast_pay_q1_2020'
export const NEEDS_VEHICLE_INFO = 'needs_vehicle_info'
export const DX_EXTREME_LATENESS = 'dx_extreme_lateness'
export const W_MODEL_EXPERIMENT = 'w_model_experiment'
export const NEEDS_OFFER_LETTER = 'needs_offer_letter'
export const DX_PHONE_NUMBER_VERIFICATION = 'phone_number_verification'
export const TOKENIZATION = 'tokenization'
export const DX_WEB_JAPAN_SUPPORT = 'dx_web_jpn_support'
export const DX_PHONE_NUMBER_VERIFICATION_SIGNUP =
  'dasher_phone_number_verification_signup'
export const NO_W9_EXPERIMENT = 'no_w9_experiment'
export const IDENTITY_VERIFICATION = 'identity_verification'

export default {
  RETURN_TO_APPLICATION_AUTO,
  INSTANT_DASHING_V2,
  IS_AT_CAPACITY_V2,
  DX_CRO_LP_GRADUATION_Q1_2020,
  DX_CRO_LP_GRADUATION_Q3_2020,
  DX_ID_FAST_PAY_Q1_2020,
  NEEDS_VEHICLE_INFO,
  DX_EXTREME_LATENESS,
  W_MODEL_EXPERIMENT,
  NEEDS_OFFER_LETTER,
  DX_PHONE_NUMBER_VERIFICATION,
  TOKENIZATION,
  DX_WEB_JAPAN_SUPPORT,
  DX_PHONE_NUMBER_VERIFICATION_SIGNUP,
  NO_W9_EXPERIMENT,
  IDENTITY_VERIFICATION,
}
